import Dialog from './Dialog.js';
import AjaxLoader from './AjaxLoader.js';
import FormHandler from './FormHandler.js';
import InlineScriptRunner from './InlineScriptRunner.js';
import SuccessWatcher from './SuccessWatcher.js';

document.addEventListener('DOMContentLoaded', () => {
  const widget = document.getElementById('advice-widget');
  const body = document.getElementById('advice-body');
  const trigger = document.getElementById('advice-trigger');
  const closeButton = document.getElementById('advice-close');
  let preloadedHtml = null;

  if (!widget || !body || !trigger || !closeButton) return;

  const dialog = new Dialog(widget, body, trigger, closeButton);
  const ajaxLoader = new AjaxLoader();
  const formHandler = new FormHandler(body, dialog, ajaxLoader);

  /**
   * Lädt die Startseite des Dialogs vor, um beim ersten Klick keine Ladezeit zu haben.
   */
  const preload = async () => {
    preloadedHtml = await ajaxLoader.load('/beratung-anfordern');
  };
  preload();

  /**
   * Öffnet den Dialog und lädt die gewünschte URL.
   * @param {string} url - Ziel-URL
   * @param {boolean} isForm - true, wenn ein Formular geladen wird
   */
  const openDialog = async (url = '/beratung-anfordern', isForm = false) => {
    dialog.open(isForm);
    let html = preloadedHtml;
    if (!html || url !== '/beratung-anfordern') {
      html = await ajaxLoader.load(url);
    }
    body.innerHTML = html;

    body.querySelectorAll('form').forEach(form => {
      form.dataset.originalAction = url;
    });

    new InlineScriptRunner().run(body);
    formHandler.initAllForms(body);
    new SuccessWatcher(body, () => dialog.close()).start();
    initLinks();
    initBackButton();
  };

  /**
   * Initialisiert Link-Verhalten im Dialog.
   */
  const initLinks = () => {
    body.querySelectorAll('a[href]').forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href) return;

        if (href.includes('/ueber-uns/team')) {
          dialog.close();
          return;
        }

        e.preventDefault();
        const isFormRoute =
          href.includes('rueckruf-anfordern') ||
          href.includes('terminanfrage') ||
          href.includes('/kontakt/');
        openDialog(href, isFormRoute);
      });
    });
  };

  /**
   * Initialisiert Zurück-Button, wenn vorhanden.
   */
  const initBackButton = () => {
    const backBtn = body.querySelector('.content-element-advice--back');
    if (backBtn) {
      backBtn.addEventListener('click', (e) => {
        e.preventDefault();
        formHandler.goBack();
      });
    }
  };

  /**
   * Öffnen & Schließen per Trigger.
   */
  trigger.addEventListener('click', () => {
    if (dialog.isOpen) {
      dialog.close();
    } else {
      if (body.innerHTML.trim() !== '') {
        dialog.open();
      } else {
        openDialog();
      }
    }
  });

  /**
   * ESC schließt den Dialog.
   */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dialog.isOpen) dialog.close();
  });
});
